import { Button as MuiButton, ButtonProps, styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface BaseButtonProps extends ButtonProps {
  to?: string;
  component?: typeof RouterLink;
}

// Base styled button with common properties
export const BaseButton = styled(MuiButton)<BaseButtonProps>(({ theme }) => ({
  textTransform: 'none',
  transition: 'all 0.3s ease-in-out',
}));

// Primary action button (Member Login)
export const PrimaryButton = styled(BaseButton)(({ theme }) => ({
  bgcolor: theme.palette.purple.main,
  color: theme.palette.lime,
  borderRadius: '100px',
  padding: '12px 24px',
  fontSize: '1.1rem',
  fontWeight: 600,
  border: `2px solid ${theme.palette.purple.light}`,
  boxShadow: `0 2px 4px ${theme.palette.purple.main}40`,
  '&:hover': {
    bgcolor: theme.palette.purple.dark,
    transform: 'translateY(-2px)',
    border: `2px solid ${theme.palette.purple.main}`,
    boxShadow: `
      0 4px 8px ${theme.palette.purple.main}40,
      0 0 0 4px ${theme.palette.purple.light}15
    `,
    color: theme.palette.lime,
  },
  '&:active': {
    bgcolor: theme.palette.purple.darker,
    transform: 'translateY(0)',
    boxShadow: `0 1px 2px ${theme.palette.purple.main}40`,
    color: theme.palette.lime,
  },
}));

// Navigation button with hover effects
export const NavButton = styled(BaseButton)(({ theme }) => ({
  padding: '0.5rem 1rem',
  fontWeight: 700,
  background: theme.palette.background.paper,
  color: theme.palette.primary.main,
  borderRadius: '0.5rem',
  borderBottom: `2px solid ${theme.palette.primary.main}`,
  borderRight: `2px solid ${theme.palette.primary.main}`,
  borderTop: '2px solid transparent',
  borderLeft: '2px solid transparent',
  '&:hover': {
    background: theme.palette.background.paper,
    borderTop: `2px solid ${theme.palette.primary.main}`,
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    borderBottom: `2px solid ${theme.palette.primary.light}`,
    borderRight: `2px solid ${theme.palette.primary.light}`,
    boxShadow: `
      ${theme.palette.primary.light}66 5px 5px,
      ${theme.palette.primary.light}4D 10px 10px,
      ${theme.palette.primary.light}33 15px 15px
    `,
  },
}));

// Secondary/outline button
export const OutlineButton = styled(BaseButton)(({ theme }) => ({
  borderColor: 'divider',
  color: 'text.primary',
  borderRadius: '100px',
  padding: '12px 24px',
  fontSize: '1.1rem',
  '&:hover': {
    borderColor: 'text.primary',
    bgcolor: 'transparent',
    transform: 'translateY(-2px)',
  },
})); 